import { useState } from 'react';
import { Button, Icon, Sheet, Tooltip } from '@gravity-ui/uikit';

import { BLOCK_BLANC, EDIT_BLANK, UNBLOCK_BLANC } from 'features/admin-mode/constants';
import { AccountBlockModal, AccountEditModal } from '../modals';
import { AccountUnblockModal } from '../modals/account-unblock-modal';

import { EllipsisVertical, Xmark } from '@gravity-ui/icons';
import { AccountBlockSheet, AccountEditSheet, AccountUnblockSheet } from '../sheets';

import styles from './styles.module.scss';

export const AdminListBlock = ({ account, onAdd, updateAccountStatus, isMobile }: any) => {
	const [visible, setVisible] = useState(false);
	return (
		<div key={account.id} className={account.active ? styles.list_block : styles.list_block__unactive}>
			<div className={styles.list_block__user}>
				<div className={styles.list_block__user__info}>
					<h3>Имя специалиста</h3>
					<p>{`${account.lastName} ${account.firstName} ${account.middleName} `}</p>
				</div>

				<div className={styles.list_block__user__info}>
					<h3>Учреждение</h3>
					<p>{account.establishment?.name ?? '—'}</p>
				</div>

				<div className={styles.list_block__user__email}>
					<div className={styles.list_block__user__info}>
						<h3>Дата</h3>
						<p> {account.createdDate}</p>
					</div>
					<div className={styles.list_block__user__info}>
						<h3>Email</h3>
						<p> {account.email}</p>
					</div>
				</div>
			</div>
			<div className={styles.list_block__panel}>
				{isMobile ? (
					<>
						<Button view="flat" onClick={() => setVisible(true)}>
							<Icon data={EllipsisVertical} size={16} />
						</Button>
						<Sheet
							visible={visible}
							onClose={() => setVisible(false)}
							title="Меню аккаунта"
							className={styles.sheet}
						>
							<div>
								<div className={styles.sheet__close}>
									<Button onClick={() => setVisible(false)} view="flat">
										<Icon data={Xmark} size={16} />
									</Button>
								</div>
								{account.active ? (
									<>
										<Tooltip
											className={styles.list_block__panel__tooltip}
											content={EDIT_BLANK}
											placement="top"
											openDelay={500}
										>
											<div tabIndex={0}>
												<AccountEditSheet account={account} onAdd={onAdd} key={account.id} />
											</div>
										</Tooltip>

										<Tooltip
											className={styles.list_block__panel__tooltip}
											content={BLOCK_BLANC}
											placement="top"
											openDelay={500}
										>
											<div tabIndex={0}>
												<AccountBlockSheet
													account={account}
													onAdd={onAdd}
													updateAccountStatus={updateAccountStatus}
												/>
											</div>
										</Tooltip>
									</>
								) : (
									<Tooltip
										className={styles.list_block__panel__tooltip}
										content={UNBLOCK_BLANC}
										placement="top"
										openDelay={500}
									>
										<div tabIndex={0}>
											<AccountUnblockSheet
												account={account}
												onAdd={onAdd}
												updateAccountStatus={updateAccountStatus}
											/>
										</div>
									</Tooltip>
								)}
							</div>
						</Sheet>
					</>
				) : (
					<>
						{account.active ? (
							<>
								<Tooltip
									className={styles.list_block__panel__tooltip}
									content={EDIT_BLANK}
									placement="top"
									openDelay={500}
								>
									<div tabIndex={0}>
										<AccountEditModal account={account} onAdd={onAdd} key={account.id} />
									</div>
								</Tooltip>

								<Tooltip
									className={styles.list_block__panel__tooltip}
									content={BLOCK_BLANC}
									placement="top"
									openDelay={500}
								>
									<div tabIndex={0}>
										<AccountBlockModal
											account={account}
											onAdd={onAdd}
											updateAccountStatus={updateAccountStatus}
										/>
									</div>
								</Tooltip>
							</>
						) : (
							<Tooltip
								className={styles.list_block__panel__tooltip}
								content={UNBLOCK_BLANC}
								placement="top"
								openDelay={500}
							>
								<div tabIndex={0}>
									<AccountUnblockModal
										account={account}
										onAdd={onAdd}
										updateAccountStatus={updateAccountStatus}
									/>
								</div>
							</Tooltip>
						)}
					</>
				)}
			</div>
		</div>
	);
};
